<template>
  <div class="voltar-button">
    <router-link class="text--white" :to="{ path: path }">
      <svg viewBox="0 0 24 24">
        <path
          fill="#000"
          d="M20,10V14H11L14.5,17.5L12.08,19.92L4.16,12L12.08,4.08L14.5,6.5L11,10H20Z"
        />
      </svg>
      <span v-if="!hideText">Voltar</span>
    </router-link>
  </div>
</template>
<script lang="js">
export default {
  name: "ButtonVoltar",
  props: ["path", "hideText"],
};
</script>
<style lang="scss" scoped>
#jns {
  .text--white {
    a {
      font-weight: bold;
      color: #fff !important;
      svg path {
        fill: #fff !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/ButtonVoltar.vue